


















































































































































































































































































































































































































import {Component, Vue} from 'vue-property-decorator';
import {HomeIcon} from '@/assets/inconfont/home';
import {HomeOver} from '@/static/home';

const Tactics = {};
// @ts-ignore
@Component({
  components: {
    HomeIcon,
  }
})
export default class HomeOverView extends Vue {
  private pageData = HomeOver;

  mounted() {
  }

}
